// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Archives extends APIResource {
    /**
     * Attach an archive to an agent.
     */
    attach(archiveID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/archives/attach/${archiveID}`, options);
    }
    /**
     * Detach an archive from an agent.
     */
    detach(archiveID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/archives/detach/${archiveID}`, options);
    }
}
//# sourceMappingURL=archives.mjs.map